import { apiClient, ApiName } from '@shared/services/api'

export const fetchCompletedOperations = (config) => {
  return apiClient.get(ApiName.ADMINS, 'operations/pos?status=CLOSE', config)
}
